module.exports = __webpack_public_path__ + "static/media/results.7891a53a.jpg";